"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Schedule = void 0;
var _react = require("react");
var _TaskManager = require("../../../TaskManager.provider");
var _GradeAndFeedbackTime = require("./partials/GradeAndFeedbackTime");
var _ShowGradeAndFeedback = require("./partials/ShowGradeAndFeedback");
var _TaskDateTimePicker = require("./partials/TaskDateTimePicker");
var _Schedule = _interopRequireDefault(require("./Schedule.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Schedule = props => {
  const {
    isHideGradeChangeEnabled = true
  } = props;
  const {
    task
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const styles = (0, _Schedule.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__schedule'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TaskDateTimePicker.TaskDateTimePicker, {
      ...props
    }), task && !(task.taskType === 'learningWork' || task.taskType === 'selfLearning') && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-TaskManager__schedule__grade-and-feedback'],
      children: [isHideGradeChangeEnabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShowGradeAndFeedback.ShowGradeAndFeedback, {
        ...props
      }), task && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradeAndFeedbackTime.GradeAndFeedbackTime, {
        ...props
      })]
    })]
  });
};
exports.Schedule = Schedule;